import React from "react";
import { DevList } from "./DevList";
import { TopNav } from "./TopNav";
function DevPageComp({props}) {
  return (
    <>
      <div className="dev--wrapper">
        <main className="dev--main">
          <TopNav  path={props.location.pathname}/>
          <DevList />
        </main>
      </div>
    </>
  );
}

export { DevPageComp };
